define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/heading/ActionData",
	"csi/heading/Enum",
	"csi/heading/stateColorResolver",
	"csi/xml"
], function(array, declare, lang, Memory, csi, ActionData, Enum, stateColorResolver, xml) {

	var EMPTY = "__EMPTY__";

	return declare(Enum, {
		// should be rendered as upper case text
		capitalized: true,

		/**
		 * @override
		 * Changes to enum happen through actions, not by picking a new value from an aggregate store
		 */
		hasAggregateStore(ctx, h) {
			return false;
		},

		getStore: function(/*Context*/ctx, /*Heading*/h, /*String*/value, /*Boolean*/bAll) {
			// summary: return store filled with possible state-transition actions
			var items = csi.transform(h.m_defActions.getActions(), function(a) {
				return a.hasAccess(ctx) ? {id: a.m_id, name: a.m_name} : null;
			});

			// unfortunately the select control does not like empty id, so use non-empty one
			items = items || [];
			items.unshift({id: EMPTY, name: ""});
			return new Memory({data: items});
		},

		/**
		 * @override
		 * Apply actions to drop-down rather than tooltip
		 */
		headingToTooltip: function(ctx, h, tooltip) {
			return this.toTooltip(ctx, h, tooltip);
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: create store for enumeration values and select control to edit
			params.value = EMPTY;
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Apply the styling if needed
		 */
		_getRenderCSS: function(ctx, h) {
			const node = ctx.getNode();
			const revisionNode = ctx.getNode(node?.CurrentRevision);

			return this.inherited(arguments) + " " + stateColorResolver.getStateCss(revisionNode);
		},

		disableAction: function(/*Context*/ctx) {
			return ctx.isReadOnly();
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return ActionData for rendering with any settings from heading; note that the
			// action is shared - a new action is not created
			var node = ctx.getNode();

			// normal Action.hasAccess won't work because need to allow action when node is frozen
			if (ctx.bPrint ||
				this.disableAction(ctx) ||
				!h.m_action ||
				xml.nodeHasFlag(node, xml.NODE_FLAG_NOEDIT) ||
				!xml.nodeHasRight(node, h.m_action.m_right)
			) {
				return null;
			}

			if (!h.m_defActions || array.every(h.m_defActions.getActions(), (a) => !a.hasAccess(ctx))) {
				return null;
			}

			const action = this.getAction(ctx, h);

			return lang.mixin(new ActionData(), {
				action,
				heading: h,
				ren: this
			});
		}
	});
});